
import Immutable from 'seamless-immutable';

import { actions } from './actions';

/* ------------- Auth reducer ------------- */
const defaultState = {
  loading: true,
  error: null,
  admin: [],
  editor: [],
  adminMap: {},
  editorMap: {},
};

function makePermissionMap(permissions) {
  const result = {};
  Object.values(permissions).forEach(({ enabled, code }) => {
    result[code] = enabled;
  });
  return result;
}

/* eslint-enable complexity */
// eslint-disable-next-line import/prefer-default-export
export function reducer(state = Immutable(defaultState), action) {
  switch (action.type) {
    case actions.CLEAR: {
      return state.merge(defaultState);
    }
    case actions.LOAD_START: {
      return state.merge({
        loading: true,
      });
    }
    case actions.LOAD_SUCCESS: {
      const { admin, editor } = action.payload;
      return state.merge({
        admin,
        editor,
        loading: false,
        error: null,
        adminMap: makePermissionMap(admin),
        editorMap: makePermissionMap(editor),
      });
    }
    case actions.LOAD_FAIL: {
      const { error } = action.payload;
      return state.merge({
        error,
        loading: false,
      });
    }
    case actions.UPDATE_START: {
      return state.merge({
        loading: true,
      });
    }
    case actions.UPDATE_SUCCESS: {
      return state.merge({
        loading: false,
      });
    }
    case actions.UPDATE_FAIL: {
      const { error } = action.payload;
      return state.merge({
        error,
        loading: false,
      });
    }
    default: {
      return state;
    }
  }
}
/* eslint-disable complexity */



// WEBPACK FOOTER //
// ./src/redux/RolePermissions/reducer.js